import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultProcessAreaRoleRelationResource,
    ProcessAreaRoleRelationMutationResourceSchema,
    useProcessAreaRoleRelationActions,
} from '../../../../../resource/resources/artifacts/role/processAreaRoleRelationResource';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { ProcessAreaRoleRelationContent } from './ProcessAreaRoleRelationContent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { Text } from '@mantine/core';

export const ProcessAreaRoleRelationView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const processAreaRoleRelationActions = useProcessAreaRoleRelationActions()
    const processAreaRoleRelationQuery = processAreaRoleRelationActions.useGetResource(id);
    const updateProcessAreaRoleRelation = processAreaRoleRelationActions.useUpdateResource();
    const validateProcessAreaRoleRelation = processAreaRoleRelationActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProcessAreaRoleRelationMutationResourceSchema,
        defaultValues: defaultProcessAreaRoleRelationResource,
        submitHandler: async (data) => {
            await updateProcessAreaRoleRelation.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: processAreaRoleRelationQuery.data,
    });

    return (
        <QueryBaseComponent name="ProcessAreaRoleRelation" query={processAreaRoleRelationQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateProcessAreaRoleRelation.data}
                    metaDataInfo={processAreaRoleRelationQuery.data}
                    resourceType={ResourceType.PROCESS_AREA_ROLE_RELATION}
                >
                    <Text c="dimmed">Role Relation</Text>
                </ResourceValidationTitleBar>
                <ProcessAreaRoleRelationContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
